import type { 
  ClientId, 
  RecommendationId, 
  IntegrityReportId,
  InspectionId,
  EquipmentId
} from "../../shared/kernel/identifiers.js";
import type { ZrHistoryEntry } from "./zr-numbering.js";

export type RecommendationExecuteIn = 'ROUTINE' | 'SHUTDOWN';
export type RecommendationCriticality = 'LOW' | 'MODERATE' | 'HIGH' | 'CRITICAL';

export interface Recommendation {
  id: RecommendationId;
  recommendationNumber?: string;
  code?: string;
  clientId: ClientId;
  integrityReportId: IntegrityReportId;

  inspectionId: InspectionId | null;
  projectId?: string | null;
  unitAreaId?: string | null;
  equipmentId: EquipmentId | null;
  componentId: string | null;
  componentName?: string | null;
  checklistItemId: string | null;

  discipline: string;
  criticality: RecommendationCriticality;
  executeIn: RecommendationExecuteIn;
  scope: string;
  /** Numeração ZR. Nulo significa PENDENTE DE NUMERAÇÃO — não é ausência de recomendação. */
  zr: string | null;
  /** Rastro append-only da numeração: atribuições, alterações e remoções. */
  zrHistory?: ZrHistoryEntry[];

  location?: string | null;
  dimension?: string | null;
  technicalData?: string | null;
  observations?: string | null;

  version: number;
  createdAt: string;
  updatedAt: string;
}

export function validateRecommendationCreation(recommendation: Recommendation): void {
  // CHECKLIST-REC-FK-01: Recommendations podem existir ANTES do RI oficial (vinculadas por inspectionId).
  // integrityReportId é opcional na criação via Checklist; será preenchido quando o RI for criado.
  // Validação de vínculo com RI real ocorre no ReportService ao criar/vincular o RI.
  if (!recommendation.inspectionId) {
    throw new Error('Recommendations must be linked to an Inspection');
  }
}
